import React from "react";
import moment from "moment/moment";
function EventList({ event, onViewAttendees, showAttendeesButton }) {
  const today = new Date();
  const eventDate = new Date(event.date);
  today.setHours(0, 0, 0, 0);
  eventDate.setHours(0, 0, 0, 0);

  const isUpcoming = eventDate >= today;

  return (
    <div className="relative flex flex-row flex-wrap sm:flex-nowrap shadow rounded-lg border border-gray-200 items-center py-3 sm:p-2 px-4 w-full mb-2">
      {/* Event Date */}
      <div className="basis-[calc(100%-120px)] sm:basis-1/2 flex flex-row sm:flex-col items-center sm:items-start gap-3 sm:gap-0 pr-3 sm:pr-0">
        {isUpcoming && (
          <span className="order-2 sm:order-none inline-block text-xs font-normal px-3 sm:px-2 py-1 sm:py-0.5 rounded-full w-fit bg-red-100 text-red-700">
            Upcoming
          </span>
        )}
        <span className="order-1 sm:order-none text-base font-medium leading-none sm:leading-normal text-gray-800 whitespace-nowrap overflow-hidden text-ellipsis">
          {moment(event.date).format("MM-DD-YYYY")}
        </span>
      </div>

      {/* Event Details */}
      <div className="basis-[calc(100%-120px)] sm:basis-3/4 mt-2 sm:mt-0 text-lg overflow-hidden text-ellipsis truncate pr-3 sm:pr-0">
        <span className="block truncate max-w-full sm:max-w-[200px] text-base font-semibold leading-none sm:leading-normal text-gray-900 uppercase">
          {event.name}
        </span>
        <span className="block break-words max-w-full sm:max-w-[300px]">
          <span className="hidden sm:inline">{event.description}</span>
          <p className="pt-1 text-sm leading-none sm:leading-normal text-gray-600 break-words truncate sm:whitespace-normal sm:overflow-visible sm:text-clip">
            {event.city}
            <span className="px-3 sm:px-2 text-gray-400"> |</span>
            {event.state}
          </p>
        </span>
      </div>

      {/* Button */}
      {showAttendeesButton && (
        <div className="absolute right-4 top-1/2 -translate-y-1/2 sm:static sm:basis-1/4 sm:translate-y-0 flex justify-end items-center">
          <button
            type="button"
            onClick={onViewAttendees}
            className="bg-blue-700 hover:bg-blue-800 text-white px-3 py-1.5 rounded-md text-sm font-normal transition-colors"
          >
            Attendees
          </button>
        </div>
      )}
    </div>
  );
}

export default EventList;
